import React, { useState } from "react";

import {
    Link,
    useNavigate
} from "react-router-dom";

import Swal from "sweetalert2";

import {
    FaUser,
    FaIdCard,
    FaEnvelope,
    FaPhoneAlt,
    FaUniversity,
    FaCity,
    FaMapMarkerAlt,
    FaCalendarAlt,
    FaLock,
    FaEye,
    FaEyeSlash,
    FaArrowRight,
    FaSignInAlt,
    FaGraduationCap,
    FaCheckCircle,
    FaShieldAlt,
    FaBookMedical
} from "react-icons/fa";

import {
    userSignup
} from "../config/userApi";


function Signup() {

    const navigate = useNavigate();


    /*
    |--------------------------------------------------------------------------
    | Form Data
    |--------------------------------------------------------------------------
    */

    const [formData, setFormData] = useState({

        user_id: "",
        full_name: "",
        email: "",
        mobile: "",
        college: "",
        city: "",
        address: "",
        batch_year: "",
        password: "",
        confirm_password: ""

    });


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    const [loading, setLoading] = useState(false);


    /*
    |--------------------------------------------------------------------------
    | Password Visibility
    |--------------------------------------------------------------------------
    */

    const [showPassword, setShowPassword] = useState(false);

    const [showConfirmPassword, setShowConfirmPassword] =
        useState(false);


    /*
    |--------------------------------------------------------------------------
    | Handle Change
    |--------------------------------------------------------------------------
    */

    const handleChange = (e) => {

        const {
            name,
            value
        } = e.target;


        /*
        |--------------------------------------------------------------------------
        | Mobile Number
        |--------------------------------------------------------------------------
        */

        if (name === "mobile") {

            const numericValue =
                value
                    .replace(/\D/g, "")
                    .slice(0, 10);


            setFormData((previousData) => ({

                ...previousData,

                mobile: numericValue

            }));


            return;
        }


        /*
        |--------------------------------------------------------------------------
        | Batch Year
        |--------------------------------------------------------------------------
        */

        if (name === "batch_year") {

            const numericValue =
                value
                    .replace(/\D/g, "")
                    .slice(0, 4);


            setFormData((previousData) => ({

                ...previousData,

                batch_year: numericValue

            }));


            return;
        }


        /*
        |--------------------------------------------------------------------------
        | Normal Fields
        |--------------------------------------------------------------------------
        */

        setFormData((previousData) => ({

            ...previousData,

            [name]: value

        }));

    };


    /*
    |--------------------------------------------------------------------------
    | Handle Submit
    |--------------------------------------------------------------------------
    */

    const handleSubmit = async (e) => {

        e.preventDefault();


        /*
        |--------------------------------------------------------------------------
        | Clean Form Data
        |--------------------------------------------------------------------------
        */

        const cleanFormData = {

            user_id:
                formData.user_id.trim(),

            full_name:
                formData.full_name.trim(),

            email:
                formData.email.trim().toLowerCase(),

            mobile:
                formData.mobile.trim(),

            college:
                formData.college.trim(),

            city:
                formData.city.trim(),

            address:
                formData.address.trim(),

            batch_year:
                String(
                    formData.batch_year
                ).trim(),

            password:
                formData.password,

            confirm_password:
                formData.confirm_password

        };


        /*
        |--------------------------------------------------------------------------
        | User ID Validation
        |--------------------------------------------------------------------------
        */

        if (!cleanFormData.user_id) {

            Swal.fire({

                icon: "warning",

                title: "User ID Required",

                text:
                    "Please enter your User ID."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Full Name Validation
        |--------------------------------------------------------------------------
        */

        if (!cleanFormData.full_name) {

            Swal.fire({

                icon: "warning",

                title: "Full Name Required",

                text:
                    "Please enter your full name."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Email Validation
        |--------------------------------------------------------------------------
        */

        if (!cleanFormData.email) {

            Swal.fire({

                icon: "warning",

                title: "Email Required",

                text:
                    "Please enter your email address."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Email Format Validation
        |--------------------------------------------------------------------------
        */

        const emailPattern =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


        if (
            !emailPattern.test(
                cleanFormData.email
            )
        ) {

            Swal.fire({

                icon: "warning",

                title: "Invalid Email",

                text:
                    "Please enter a valid email address."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Mobile Validation
        |--------------------------------------------------------------------------
        */

        if (!cleanFormData.mobile) {

            Swal.fire({

                icon: "warning",

                title: "Mobile Required",

                text:
                    "Please enter your mobile number."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Mobile Format Validation
        |--------------------------------------------------------------------------
        */

        const mobilePattern =
            /^[6-9]\d{9}$/;


        if (
            !mobilePattern.test(
                cleanFormData.mobile
            )
        ) {

            Swal.fire({

                icon: "warning",

                title: "Invalid Mobile Number",

                text:
                    "Please enter a valid 10 digit Indian mobile number."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | College Validation
        |--------------------------------------------------------------------------
        */

        if (!cleanFormData.college) {

            Swal.fire({

                icon: "warning",

                title: "College Required",

                text:
                    "Please enter your college name."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | City Validation
        |--------------------------------------------------------------------------
        */

        if (!cleanFormData.city) {

            Swal.fire({

                icon: "warning",

                title: "City Required",

                text:
                    "Please enter your city."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Address Validation
        |--------------------------------------------------------------------------
        */

        if (!cleanFormData.address) {

            Swal.fire({

                icon: "warning",

                title: "Address Required",

                text:
                    "Please enter your address."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Batch Year Validation
        |--------------------------------------------------------------------------
        */

        if (!cleanFormData.batch_year) {

            Swal.fire({

                icon: "warning",

                title: "Batch Year Required",

                text:
                    "Please enter your batch year."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Batch Year Format
        |--------------------------------------------------------------------------
        */

        const batchYear =
            Number(
                cleanFormData.batch_year
            );


        if (

            !Number.isInteger(batchYear) ||

            batchYear < 2000 ||

            batchYear > 2100

        ) {

            Swal.fire({

                icon: "warning",

                title: "Invalid Batch Year",

                text:
                    "Please enter a valid batch year."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Password Validation
        |--------------------------------------------------------------------------
        */

        if (!cleanFormData.password) {

            Swal.fire({

                icon: "warning",

                title: "Password Required",

                text:
                    "Please enter your password."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Password Length
        |--------------------------------------------------------------------------
        */

        if (
            cleanFormData.password.length < 6
        ) {

            Swal.fire({

                icon: "warning",

                title: "Weak Password",

                text:
                    "Password must be at least 6 characters."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Confirm Password Validation
        |--------------------------------------------------------------------------
        */

        if (
            !cleanFormData.confirm_password
        ) {

            Swal.fire({

                icon: "warning",

                title: "Confirm Password Required",

                text:
                    "Please confirm your password."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Password Match
        |--------------------------------------------------------------------------
        */

        if (

            cleanFormData.password !==
            cleanFormData.confirm_password

        ) {

            Swal.fire({

                icon: "warning",

                title: "Password Mismatch",

                text:
                    "Password and confirm password do not match."

            });

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | API Request
        |--------------------------------------------------------------------------
        */

        try {

            setLoading(true);


            console.log(
                "================================"
            );

            console.log(
                "USER SIGNUP REQUEST"
            );

            console.log(
                "User ID:",
                cleanFormData.user_id
            );

            console.log(
                "Full Name:",
                cleanFormData.full_name
            );

            console.log(
                "Email:",
                cleanFormData.email
            );

            console.log(
                "Mobile:",
                cleanFormData.mobile
            );

            console.log(
                "College:",
                cleanFormData.college
            );

            console.log(
                "City:",
                cleanFormData.city
            );

            console.log(
                "Batch Year:",
                cleanFormData.batch_year
            );

            console.log(
                "================================"
            );


            /*
            |--------------------------------------------------------------------------
            | Call Signup API
            |--------------------------------------------------------------------------
            */

            const response =
                await userSignup(
                    cleanFormData
                );


            /*
            |--------------------------------------------------------------------------
            | Response Status
            |--------------------------------------------------------------------------
            */

            console.log(
                "Response Status:",
                response.status
            );

            console.log(
                "Response OK:",
                response.ok
            );


            /*
            |--------------------------------------------------------------------------
            | Read Response
            |--------------------------------------------------------------------------
            */

            const responseText =
                await response.text();


            console.log(
                "Raw Laravel Response:",
                responseText
            );


            /*
            |--------------------------------------------------------------------------
            | Parse Response
            |--------------------------------------------------------------------------
            */

            let data = {};


            try {

                data =
                    responseText
                        ? JSON.parse(
                            responseText
                        )
                        : {};

            } catch (error) {

                console.error(
                    "JSON Parse Error:",
                    error
                );


                Swal.fire({

                    icon: "error",

                    title: "Invalid API Response",

                    text:
                        "Laravel ने valid JSON response नहीं भेजा।"

                });


                return;

            }


            console.log(
                "Laravel JSON:",
                data
            );


            /*
            |--------------------------------------------------------------------------
            | Signup Failed
            |--------------------------------------------------------------------------
            */

            if (!response.ok) {


                /*
                |--------------------------------------------------------------------------
                | Laravel Validation Errors
                |--------------------------------------------------------------------------
                */

                if (data.errors) {

                    const errors =
                        data.errors;


                    const firstErrorKey =
                        Object.keys(
                            errors
                        )[0];


                    const firstError =
                        errors[
                            firstErrorKey
                        ];


                    let errorMessage =
                        "Please check the entered information.";


                    if (
                        Array.isArray(
                            firstError
                        )
                    ) {

                        errorMessage =
                            firstError[0];

                    } else if (
                        firstError
                    ) {

                        errorMessage =
                            String(
                                firstError
                            );

                    }


                    Swal.fire({

                        icon: "error",

                        title: "Signup Failed",

                        text:
                            errorMessage

                    });

                } else {

                    Swal.fire({

                        icon: "error",

                        title: "Signup Failed",

                        text:
                            data.message ||
                            "Unable to create account."

                    });

                }


                return;

            }


            /*
            |--------------------------------------------------------------------------
            | Signup Successful
            |--------------------------------------------------------------------------
            */

            console.log(
                "================================"
            );

            console.log(
                "✅ USER SIGNUP SUCCESSFUL"
            );

            console.log(
                "Laravel Response:",
                data
            );

            console.log(
                "================================"
            );


            /*
            |--------------------------------------------------------------------------
            | Success Message
            |--------------------------------------------------------------------------
            */

            await Swal.fire({

                icon: "success",

                title: "Registration Successful",

                text:
                    data.message ||
                    "Your account has been created successfully.",

                timer: 1800,

                showConfirmButton: false

            });


            /*
            |--------------------------------------------------------------------------
            | Redirect To Login
            |--------------------------------------------------------------------------
            */

            navigate(
                "/login"
            );


        } catch (error) {

            console.error(
                "================================"
            );

            console.error(
                "USER SIGNUP ERROR:"
            );

            console.error(
                error
            );

            console.error(
                "================================"
            );


            Swal.fire({

                icon: "error",

                title: "Connection Error",

                text:
                    error.message ||
                    "Unable to connect with server."

            });


        } finally {

            setLoading(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Reusable Input Style
    |--------------------------------------------------------------------------
    */

    const inputStyle = {

        background: "#f6f9fc",

        border: "1px solid #e4eaf2",

        borderRadius: "12px",

        boxShadow: "none",

        fontSize: "14px",

        padding: "11px 14px"

    };


    /*
    |--------------------------------------------------------------------------
    | Return
    |--------------------------------------------------------------------------
    */

    return (

        <div
            className="min-vh-100 position-relative d-flex align-items-center justify-content-center overflow-hidden py-4"
            style={{
                background:
                    "linear-gradient(135deg, #edf6ff 0%, #f8fbff 45%, #eefbf6 100%)"
            }}
        >


            {/* ==============================================================
                BACKGROUND DECORATION
            ============================================================== */}

            <div
                className="position-absolute rounded-circle"
                style={{
                    width: "420px",
                    height: "420px",
                    top: "-220px",
                    left: "-170px",
                    background:
                        "rgba(13,110,253,0.08)",
                    pointerEvents: "none"
                }}
            ></div>


            <div
                className="position-absolute rounded-circle"
                style={{
                    width: "360px",
                    height: "360px",
                    bottom: "-190px",
                    right: "-130px",
                    background:
                        "rgba(25,135,84,0.08)",
                    pointerEvents: "none"
                }}
            ></div>


            {/* ==============================================================
                FLOATING MEDICAL ICON
            ============================================================== */}

            <div
                className="position-absolute d-none d-lg-flex align-items-center justify-content-center rounded-circle"
                style={{
                    width: "70px",
                    height: "70px",
                    top: "12%",
                    left: "8%",
                    background:
                        "rgba(255,255,255,0.75)",
                    border:
                        "1px solid rgba(13,110,253,0.12)",
                    boxShadow:
                        "0 15px 35px rgba(30,60,90,0.10)"
                }}
            >

                <FaBookMedical
                    className="text-primary"
                    size={28}
                />

            </div>


            <div
                className="position-absolute d-none d-lg-flex align-items-center justify-content-center rounded-circle"
                style={{
                    width: "70px",
                    height: "70px",
                    bottom: "12%",
                    right: "8%",
                    background:
                        "rgba(255,255,255,0.75)",
                    border:
                        "1px solid rgba(25,135,84,0.12)",
                    boxShadow:
                        "0 15px 35px rgba(30,60,90,0.10)"
                }}
            >

                <FaGraduationCap
                    className="text-success"
                    size={28}
                />

            </div>


            {/* ==============================================================
                MAIN CONTAINER
            ============================================================== */}

            <div
                className="container position-relative"
                style={{
                    zIndex: 5
                }}
            >

                <div className="row justify-content-center">

                    <div className="col-12 col-xl-9 col-xxl-8">


                        {/* ==================================================
                            SIGNUP CARD
                        ================================================== */}

                        <div
                            className="rounded-4 overflow-hidden"
                            style={{
                                background:
                                    "rgba(255,255,255,0.97)",
                                border:
                                    "1px solid rgba(255,255,255,0.9)",
                                boxShadow:
                                    "0 25px 70px rgba(32,55,85,0.15)"
                            }}
                        >


                            {/* ==================================================
                                TOP GRADIENT LINE
                            ================================================== */}

                            <div
                                style={{
                                    height: "5px",
                                    background:
                                        "linear-gradient(90deg, #0d6efd, #20c997, #0d6efd)"
                                }}
                            ></div>


                            {/* ==================================================
                                HEADER
                            ================================================== */}

                            <div
                                className="text-center px-4 pt-4 pb-3"
                            >

                                <Link
                                    to="/"
                                    className="text-decoration-none"
                                >

                                    <div
                                        className="mx-auto d-flex align-items-center justify-content-center rounded-4"
                                        style={{
                                            width: "70px",
                                            height: "70px",
                                            background:
                                                "linear-gradient(135deg, #0d6efd, #084298)",
                                            boxShadow:
                                                "0 12px 30px rgba(13,110,253,0.25)"
                                        }}
                                    >

                                        <FaGraduationCap
                                            className="text-white"
                                            size={35}
                                        />

                                    </div>

                                </Link>


                                <div
                                    className="fw-bold text-primary mt-3"
                                    style={{
                                        fontSize: "13px",
                                        letterSpacing: "1.7px"
                                    }}
                                >

                                    HOMEOADDA

                                </div>


                                <h2
                                    className="fw-bold mb-1 mt-1"
                                    style={{
                                        color: "#172033",
                                        fontSize: "27px"
                                    }}
                                >

                                    Create Your Account

                                </h2>


                                <p
                                    className="text-muted mb-0"
                                    style={{
                                        fontSize: "14px"
                                    }}
                                >

                                    Start your journey towards better

                                    <span className="text-primary fw-semibold">

                                        {" "}medical exam preparation

                                    </span>

                                    .

                                </p>

                            </div>


                            {/* ==================================================
                                FORM AREA
                            ================================================== */}

                            <div className="px-4 pb-4 px-md-5 pb-md-5">


                                <form
                                    onSubmit={handleSubmit}
                                >


                                    <div className="row g-3">


                                        {/* ======================================
                                            USER ID
                                        ======================================= */}

                                        <div className="col-12 col-md-6">

                                            <label
                                                htmlFor="user_id"
                                                className="form-label fw-semibold mb-2"
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#27364b"
                                                }}
                                            >

                                                User ID

                                                <span className="text-danger ms-1">
                                                    *
                                                </span>

                                            </label>


                                            <div className="input-group">

                                                <span
                                                    className="input-group-text border-end-0"
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopRightRadius: 0,
                                                        borderBottomRightRadius: 0
                                                    }}
                                                >

                                                    <FaIdCard
                                                        className="text-primary"
                                                        size={14}
                                                    />

                                                </span>


                                                <input
                                                    id="user_id"
                                                    type="text"
                                                    className="form-control border-start-0"
                                                    name="user_id"
                                                    placeholder="Enter your user ID"
                                                    value={
                                                        formData.user_id
                                                    }
                                                    onChange={
                                                        handleChange
                                                    }
                                                    disabled={loading}
                                                    required
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopLeftRadius: 0,
                                                        borderBottomLeftRadius: 0
                                                    }}
                                                />

                                            </div>

                                        </div>


                                        {/* ======================================
                                            FULL NAME
                                        ======================================= */}

                                        <div className="col-12 col-md-6">

                                            <label
                                                htmlFor="full_name"
                                                className="form-label fw-semibold mb-2"
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#27364b"
                                                }}
                                            >

                                                Full Name

                                                <span className="text-danger ms-1">
                                                    *
                                                </span>

                                            </label>


                                            <div className="input-group">

                                                <span
                                                    className="input-group-text border-end-0"
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopRightRadius: 0,
                                                        borderBottomRightRadius: 0
                                                    }}
                                                >

                                                    <FaUser
                                                        className="text-primary"
                                                        size={14}
                                                    />

                                                </span>


                                                <input
                                                    id="full_name"
                                                    type="text"
                                                    className="form-control border-start-0"
                                                    name="full_name"
                                                    placeholder="Enter your full name"
                                                    value={
                                                        formData.full_name
                                                    }
                                                    onChange={
                                                        handleChange
                                                    }
                                                    disabled={loading}
                                                    required
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopLeftRadius: 0,
                                                        borderBottomLeftRadius: 0
                                                    }}
                                                />

                                            </div>

                                        </div>


                                        {/* ======================================
                                            EMAIL
                                        ======================================= */}

                                        <div className="col-12 col-md-6">

                                            <label
                                                htmlFor="email"
                                                className="form-label fw-semibold mb-2"
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#27364b"
                                                }}
                                            >

                                                Email Address

                                                <span className="text-danger ms-1">
                                                    *
                                                </span>

                                            </label>


                                            <div className="input-group">

                                                <span
                                                    className="input-group-text border-end-0"
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopRightRadius: 0,
                                                        borderBottomRightRadius: 0
                                                    }}
                                                >

                                                    <FaEnvelope
                                                        className="text-primary"
                                                        size={14}
                                                    />

                                                </span>


                                                <input
                                                    id="email"
                                                    type="email"
                                                    className="form-control border-start-0"
                                                    name="email"
                                                    placeholder="Enter your email"
                                                    value={
                                                        formData.email
                                                    }
                                                    onChange={
                                                        handleChange
                                                    }
                                                    disabled={loading}
                                                    autoComplete="email"
                                                    required
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopLeftRadius: 0,
                                                        borderBottomLeftRadius: 0
                                                    }}
                                                />

                                            </div>

                                        </div>


                                        {/* ======================================
                                            MOBILE
                                        ======================================= */}

                                        <div className="col-12 col-md-6">

                                            <label
                                                htmlFor="mobile"
                                                className="form-label fw-semibold mb-2"
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#27364b"
                                                }}
                                            >

                                                Mobile Number

                                                <span className="text-danger ms-1">
                                                    *
                                                </span>

                                            </label>


                                            <div className="input-group">

                                                <span
                                                    className="input-group-text border-end-0"
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopRightRadius: 0,
                                                        borderBottomRightRadius: 0
                                                    }}
                                                >

                                                    <FaPhoneAlt
                                                        className="text-primary"
                                                        size={13}
                                                    />

                                                </span>


                                                <input
                                                    id="mobile"
                                                    type="tel"
                                                    className="form-control border-start-0"
                                                    name="mobile"
                                                    placeholder="10 digit mobile number"
                                                    value={
                                                        formData.mobile
                                                    }
                                                    onChange={
                                                        handleChange
                                                    }
                                                    disabled={loading}
                                                    maxLength="10"
                                                    inputMode="numeric"
                                                    autoComplete="tel"
                                                    required
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopLeftRadius: 0,
                                                        borderBottomLeftRadius: 0
                                                    }}
                                                />

                                            </div>

                                        </div>


                                        {/* ======================================
                                            COLLEGE
                                        ======================================= */}

                                        <div className="col-12 col-md-6">

                                            <label
                                                htmlFor="college"
                                                className="form-label fw-semibold mb-2"
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#27364b"
                                                }}
                                            >

                                                College

                                                <span className="text-danger ms-1">
                                                    *
                                                </span>

                                            </label>


                                            <div className="input-group">

                                                <span
                                                    className="input-group-text border-end-0"
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopRightRadius: 0,
                                                        borderBottomRightRadius: 0
                                                    }}
                                                >

                                                    <FaUniversity
                                                        className="text-primary"
                                                        size={14}
                                                    />

                                                </span>


                                                <input
                                                    id="college"
                                                    type="text"
                                                    className="form-control border-start-0"
                                                    name="college"
                                                    placeholder="Enter your college name"
                                                    value={
                                                        formData.college
                                                    }
                                                    onChange={
                                                        handleChange
                                                    }
                                                    disabled={loading}
                                                    required
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopLeftRadius: 0,
                                                        borderBottomLeftRadius: 0
                                                    }}
                                                />

                                            </div>

                                        </div>


                                        {/* ======================================
                                            CITY
                                        ======================================= */}

                                        <div className="col-12 col-md-6">

                                            <label
                                                htmlFor="city"
                                                className="form-label fw-semibold mb-2"
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#27364b"
                                                }}
                                            >

                                                City

                                                <span className="text-danger ms-1">
                                                    *
                                                </span>

                                            </label>


                                            <div className="input-group">

                                                <span
                                                    className="input-group-text border-end-0"
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopRightRadius: 0,
                                                        borderBottomRightRadius: 0
                                                    }}
                                                >

                                                    <FaCity
                                                        className="text-primary"
                                                        size={14}
                                                    />

                                                </span>


                                                <input
                                                    id="city"
                                                    type="text"
                                                    className="form-control border-start-0"
                                                    name="city"
                                                    placeholder="Enter your city"
                                                    value={
                                                        formData.city
                                                    }
                                                    onChange={
                                                        handleChange
                                                    }
                                                    disabled={loading}
                                                    required
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopLeftRadius: 0,
                                                        borderBottomLeftRadius: 0
                                                    }}
                                                />

                                            </div>

                                        </div>


                                        {/* ======================================
                                            ADDRESS
                                        ======================================= */}

                                        <div className="col-12 col-md-6">

                                            <label
                                                htmlFor="address"
                                                className="form-label fw-semibold mb-2"
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#27364b"
                                                }}
                                            >

                                                Address

                                                <span className="text-danger ms-1">
                                                    *
                                                </span>

                                            </label>


                                            <div className="input-group">

                                                <span
                                                    className="input-group-text border-end-0"
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopRightRadius: 0,
                                                        borderBottomRightRadius: 0
                                                    }}
                                                >

                                                    <FaMapMarkerAlt
                                                        className="text-primary"
                                                        size={14}
                                                    />

                                                </span>


                                                <input
                                                    id="address"
                                                    type="text"
                                                    className="form-control border-start-0"
                                                    name="address"
                                                    placeholder="Enter your address"
                                                    value={
                                                        formData.address
                                                    }
                                                    onChange={
                                                        handleChange
                                                    }
                                                    disabled={loading}
                                                    required
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopLeftRadius: 0,
                                                        borderBottomLeftRadius: 0
                                                    }}
                                                />

                                            </div>

                                        </div>


                                        {/* ======================================
                                            BATCH YEAR
                                        ======================================= */}

                                        <div className="col-12 col-md-6">

                                            <label
                                                htmlFor="batch_year"
                                                className="form-label fw-semibold mb-2"
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#27364b"
                                                }}
                                            >

                                                Batch Year

                                                <span className="text-danger ms-1">
                                                    *
                                                </span>

                                            </label>


                                            <div className="input-group">

                                                <span
                                                    className="input-group-text border-end-0"
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopRightRadius: 0,
                                                        borderBottomRightRadius: 0
                                                    }}
                                                >

                                                    <FaCalendarAlt
                                                        className="text-primary"
                                                        size={14}
                                                    />

                                                </span>


                                                <input
                                                    id="batch_year"
                                                    type="text"
                                                    inputMode="numeric"
                                                    className="form-control border-start-0"
                                                    name="batch_year"
                                                    placeholder="e.g. 2026"
                                                    value={
                                                        formData.batch_year
                                                    }
                                                    onChange={
                                                        handleChange
                                                    }
                                                    disabled={loading}
                                                    maxLength="4"
                                                    required
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopLeftRadius: 0,
                                                        borderBottomLeftRadius: 0
                                                    }}
                                                />

                                            </div>

                                        </div>


                                        {/* ======================================
                                            PASSWORD
                                        ======================================= */}

                                        <div className="col-12 col-md-6">

                                            <label
                                                htmlFor="password"
                                                className="form-label fw-semibold mb-2"
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#27364b"
                                                }}
                                            >

                                                Password

                                                <span className="text-danger ms-1">
                                                    *
                                                </span>

                                            </label>


                                            <div className="input-group">

                                                <span
                                                    className="input-group-text border-end-0"
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopRightRadius: 0,
                                                        borderBottomRightRadius: 0
                                                    }}
                                                >

                                                    <FaLock
                                                        className="text-primary"
                                                        size={14}
                                                    />

                                                </span>


                                                <input
                                                    id="password"
                                                    type={
                                                        showPassword
                                                            ? "text"
                                                            : "password"
                                                    }
                                                    className="form-control border-start-0 border-end-0"
                                                    name="password"
                                                    placeholder="Create password"
                                                    value={
                                                        formData.password
                                                    }
                                                    onChange={
                                                        handleChange
                                                    }
                                                    disabled={loading}
                                                    autoComplete="new-password"
                                                    required
                                                    style={{
                                                        ...inputStyle,
                                                        borderRadius: 0
                                                    }}
                                                />


                                                <button
                                                    type="button"
                                                    className="input-group-text border-start-0"
                                                    onClick={() =>
                                                        setShowPassword(
                                                            !showPassword
                                                        )
                                                    }
                                                    disabled={loading}
                                                    aria-label={
                                                        showPassword
                                                            ? "Hide password"
                                                            : "Show password"
                                                    }
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopLeftRadius: 0,
                                                        borderBottomLeftRadius: 0,
                                                        cursor: "pointer"
                                                    }}
                                                >

                                                    {showPassword ? (

                                                        <FaEyeSlash
                                                            size={14}
                                                            className="text-muted"
                                                        />

                                                    ) : (

                                                        <FaEye
                                                            size={14}
                                                            className="text-muted"
                                                        />

                                                    )}

                                                </button>

                                            </div>

                                        </div>


                                        {/* ======================================
                                            CONFIRM PASSWORD
                                        ======================================= */}

                                        <div className="col-12 col-md-6">

                                            <label
                                                htmlFor="confirm_password"
                                                className="form-label fw-semibold mb-2"
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#27364b"
                                                }}
                                            >

                                                Confirm Password

                                                <span className="text-danger ms-1">
                                                    *
                                                </span>

                                            </label>


                                            <div className="input-group">

                                                <span
                                                    className="input-group-text border-end-0"
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopRightRadius: 0,
                                                        borderBottomRightRadius: 0
                                                    }}
                                                >

                                                    <FaLock
                                                        className="text-primary"
                                                        size={14}
                                                    />

                                                </span>


                                                <input
                                                    id="confirm_password"
                                                    type={
                                                        showConfirmPassword
                                                            ? "text"
                                                            : "password"
                                                    }
                                                    className="form-control border-start-0 border-end-0"
                                                    name="confirm_password"
                                                    placeholder="Confirm password"
                                                    value={
                                                        formData.confirm_password
                                                    }
                                                    onChange={
                                                        handleChange
                                                    }
                                                    disabled={loading}
                                                    autoComplete="new-password"
                                                    required
                                                    style={{
                                                        ...inputStyle,
                                                        borderRadius: 0
                                                    }}
                                                />


                                                <button
                                                    type="button"
                                                    className="input-group-text border-start-0"
                                                    onClick={() =>
                                                        setShowConfirmPassword(
                                                            !showConfirmPassword
                                                        )
                                                    }
                                                    disabled={loading}
                                                    aria-label={
                                                        showConfirmPassword
                                                            ? "Hide confirm password"
                                                            : "Show confirm password"
                                                    }
                                                    style={{
                                                        ...inputStyle,
                                                        borderTopLeftRadius: 0,
                                                        borderBottomLeftRadius: 0,
                                                        cursor: "pointer"
                                                    }}
                                                >

                                                    {showConfirmPassword ? (

                                                        <FaEyeSlash
                                                            size={14}
                                                            className="text-muted"
                                                        />

                                                    ) : (

                                                        <FaEye
                                                            size={14}
                                                            className="text-muted"
                                                        />

                                                    )}

                                                </button>

                                            </div>

                                        </div>


                                    </div>


                                    {/* ==================================================
                                        SECURITY INFO
                                    ================================================== */}

                                    <div
                                        className="d-flex align-items-center justify-content-center gap-2 mt-4 mb-3"
                                    >

                                        <FaShieldAlt
                                            className="text-success"
                                            size={13}
                                        />

                                        <span
                                            className="text-muted"
                                            style={{
                                                fontSize: "12px"
                                            }}
                                        >

                                            Your information is kept secure

                                        </span>

                                    </div>


                                    {/* ==================================================
                                        CREATE ACCOUNT BUTTON
                                    ================================================== */}

                                    <button
                                        type="submit"
                                        className="btn w-100 py-3 fw-bold rounded-3 border-0"
                                        disabled={loading}
                                        style={{
                                            background:
                                                "linear-gradient(135deg, #0d6efd, #084298)",
                                            color: "#fff",
                                            fontSize: "15px",
                                            boxShadow:
                                                "0 10px 25px rgba(13,110,253,0.23)"
                                        }}
                                    >

                                        {loading ? (

                                            <>

                                                <span
                                                    className="spinner-border spinner-border-sm me-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>

                                                Creating Account...

                                            </>

                                        ) : (

                                            <>

                                                Create Account

                                                <FaArrowRight
                                                    className="ms-2"
                                                    size={13}
                                                />

                                            </>

                                        )}

                                    </button>


                                </form>


                                {/* ==================================================
                                    LOGIN LINK
                                ================================================== */}

                                <div
                                    className="text-center mt-4"
                                >

                                    <span
                                        className="text-muted"
                                        style={{
                                            fontSize: "14px"
                                        }}
                                    >

                                        Already have an account?

                                    </span>


                                    {" "}


                                    <Link
                                        to="/login"
                                        className="text-primary text-decoration-none fw-bold"
                                        style={{
                                            fontSize: "14px"
                                        }}
                                    >

                                        <FaSignInAlt
                                            size={12}
                                            className="me-1"
                                        />

                                        Login

                                    </Link>

                                </div>


                                {/* ==================================================
                                    HOME LINK
                                ================================================== */}

                                <div
                                    className="text-center mt-3"
                                >

                                    <Link
                                        to="/"
                                        className="text-decoration-none text-muted"
                                        style={{
                                            fontSize: "13px"
                                        }}
                                    >

                                        Back to Home

                                    </Link>

                                </div>


                            </div>


                            {/* ==================================================
                                FOOTER
                            ================================================== */}

                            <div
                                className="text-center py-3 px-3"
                                style={{
                                    background:
                                        "linear-gradient(135deg, #f6f9fc, #eef5ff)",
                                    borderTop:
                                        "1px solid #e7edf5"
                                }}
                            >

                                <div
                                    className="d-flex justify-content-center align-items-center gap-2"
                                >

                                    <FaCheckCircle
                                        className="text-success"
                                        size={13}
                                    />

                                    <small
                                        className="text-muted"
                                        style={{
                                            fontSize: "11px"
                                        }}
                                    >

                                        Trusted medical learning platform

                                    </small>

                                </div>

                            </div>


                        </div>


                        {/* ==================================================
                            COPYRIGHT
                        ================================================== */}

                        <div
                            className="text-center mt-3"
                        >

                            <small
                                className="text-muted"
                                style={{
                                    fontSize: "11px"
                                }}
                            >

                                © 2026 HomeoAdda. All rights reserved.

                            </small>

                        </div>


                    </div>

                </div>

            </div>

        </div>

    );

}


export default Signup;